import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding-bottom: 18px;
  font-family: ${(props) => props.theme.tokens.font.family};
`;

export const Label = styled.label`
  font-family: ${(props) => props.theme.tokens.font.family};
  font-size: 12.5px;
  font-weight: 700;
  color: ${(props) => props.theme.tokens.colors.muted};
  margin-bottom: 6px;
`;

export const InputStyled = styled.input`
  background-color: ${(props) => props.theme.tokens.colors.inputBg};
  color: ${(props) => props.theme.tokens.colors.ink};
  font-size: 14.5px;
  font-family: ${(props) => props.theme.tokens.font.family};
  font-weight: 600;

  border: 1.5px solid ${(props) => props.theme.tokens.colors.inputBorder};
  border-radius: 13px;
  outline: none;

  height: 40px;
  padding: 0 12px;
  box-sizing: border-box;

  &:focus {
    border-color: ${(props) => props.theme.tokens.colors.green};
  }
`;
